export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11322.d1bd85ff.jpg";